import { withDependencies, named } from '@wix/thunderbolt-ioc'
import {
	PageFeatureConfigSymbol,
	IPageWillMountHandler,
	IPropsStore,
	PropsMap,
	Props,
	IPageDidUnmountHandler,
	IAppWillMountHandler,
	FeatureStateSymbol,
} from '@wix/thunderbolt-symbols'
import { LoginButtonPageConfig } from './types'
import { name } from './symbols'
import { ISiteMembersApi, SiteMembersApiSymbol } from 'feature-site-members'
import { LoginButtonFeatureProps } from '@wix/thunderbolt-components-native'

const loginButtonPageFactory = (
	{ componentIds }: LoginButtonPageConfig,
	propsStore: IPropsStore,
	siteMembersApi: ISiteMembersApi
): IPageWillMountHandler & IPageDidUnmountHandler => {
	let onLoginCallbackId: unknown
	let onMemberDetailsRefreshCallbackId: unknown

	const updateComponentProps = async () => {
		const props: LoginButtonFeatureProps = {
			isLoggedIn: false,
			userName: '',
			onLogin: () => {
				siteMembersApi.promptLogin()
			},
			onLogout: () => {
				siteMembersApi.logout()
			},
		}
		const memberDetails = await siteMembersApi.getMemberDetails()
		if (memberDetails) {
			props.isLoggedIn = true
			props.userName = memberDetails.nickname || memberDetails.memberName || memberDetails.loginEmail
		}
		const updatePropsMap = componentIds.reduce<PropsMap>((result, compId) => ({ ...result, [compId]: props }), {})

		propsStore.update(updatePropsMap)
	}

	return {
		async pageWillMount() {
			onLoginCallbackId = siteMembersApi.registerToUserLogin(updateComponentProps)
			onMemberDetailsRefreshCallbackId = siteMembersApi.registerToMemberDetailsRefresh(updateComponentProps)
			await updateComponentProps()
		},
		async pageDidUnmount() {
			siteMembersApi.unRegisterToUserLogin(onLoginCallbackId)
			siteMembersApi.unRegisterToMemberDetailsRefresh(onMemberDetailsRefreshCallbackId)
		},
	}
}

export const LoginButtonPage = withDependencies(
	[named(PageFeatureConfigSymbol, name), Props, SiteMembersApiSymbol],
	loginButtonPageFactory
)

const loginButtonSiteFactory = (): IAppWillMountHandler => {
	return {
		async appWillMount() {},
	}
}

export const LoginButtonSite = withDependencies([named(FeatureStateSymbol, name)], loginButtonSiteFactory)
